// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3dwiZ","inputWrap":"Table_inputWrap__1CGA7","col":"Table_col__2VNF3","bmiTooltip":"Table_bmiTooltip__2CmIu"};